var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register-reward"},[(_vm.isAutoReward)?_c('autoReward',{ref:"autoRewardRef"}):_c('manualReward',{ref:"manualRewardRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }